<div class="card main list">
  <h4 class="card-header">Accounts</h4>
  <div class="card-body">
    <div *ngIf="isLoading" class="text-center py-3">
      <span class="spinner-border spinner-border-sm" role="status"></span>
    </div>
    <a
      (click)="setAccount(account)"
      *ngFor="let account of items"
      [class.disabled]="isBusy || isLoading"
      [style.pointer-events]="isBusy || isLoading ? 'none' : 'auto'"
      class="d-flex flex-column item mb-2 p-2 rounded"
    >
      <div class="name font-weight-bold">{{ account.name }}</div>
      <small *ngIf="account.ssoEnabled" class="text-muted">
        {{ "navigations.account.sso_badge" | translate }}
      </small>
      <small *ngIf="requiresEmail2fa(account)" class="text-muted">
        {{ "navigations.account.email_2fa_badge" | translate }}
      </small>
    </a>
    <div *ngIf="isSsoBusy && !isLoading" class="text-center py-2">
      <span class="spinner-border spinner-border-sm" role="status"></span>
      <span class="ml-2">{{ "navigations.account.sso_required" | translate }}</span>
    </div>
    <div *ngIf="isEmail2faBusy && !isLoading && !email2faModalOpen" class="text-center py-2">
      <span class="spinner-border spinner-border-sm" role="status"></span>
      <span class="ml-2">{{ "navigations.account.email_2fa_checking" | translate }}</span>
    </div>
    <div class="d-flex flex-column"></div>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-around">
      <div>
        <button
          [disabled]="isBusy"
          class="btn btn-block btn-light btn-lg"
          routerLink="/login"
          type="button"
        >
          {{ "navigations.back" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="email2faModalOpen" class="modal fade show d-block" tabindex="-1" role="dialog" style="background: rgba(0,0,0,0.5);">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <app-email-2fa-modal
        [step]="email2faStep"
        [maskedEmail]="email2faMaskedEmail"
        [isBusy]="isEmail2faBusy"
        [errorMessage]="email2faError"
        [resendDisabled]="email2faResendDisabled"
        (send)="onEmail2faSend()"
        (verify)="onEmail2faVerify($event)"
        (cancel)="closeEmail2faModal()"
        (resend)="onEmail2faResend()"
      ></app-email-2fa-modal>
    </div>
  </div>
</div>
